var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.props.sortable)?_c('fa-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:(_vm.tooltipData),expression:"tooltipData"}],staticClass:"fa-pull-right",attrs:{"icon":_vm.icon}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }